// import React, { useState } from 'react';
// import Layout from '../../Component/Layout/Layout';
// import '../../Styles/payments.css';

// const PaymentReport = () => {
//   const [filter, setFilter] = useState({
//     month: '',
//     year: new Date().getFullYear().toString()
//   });
//   const [showAllPayments, setShowAllPayments] = useState(false);
//   const [filteredPayments, setFilteredPayments] = useState([]);
//   const [isFiltered, setIsFiltered] = useState(false);
//   const [selectedPayment, setSelectedPayment] = useState(null);

//   // Extended payments data
//   const allPayments = [
//     {
//       id: 1,
//       paymentId: 'PAY001',
//       amount: '₹2,295',
//       date: '2024-01-20',
//       method: 'Bank Transfer',
//       status: 'Completed',
//       commissions: 3,
//       reference: 'TRX2024001',
//       commissionDetails: [
//         { bookingId: 'BK001', amount: '₹750', date: '2024-01-15' },
//         { bookingId: 'BK003', amount: '₹1,170', date: '2024-01-13' },
//         { bookingId: 'BK004', amount: '₹375', date: '2024-01-12' }
//       ]
//     },
//     {
//       id: 2,
//       paymentId: 'PAY002',
//       amount: '₹1,850',
//       date: '2023-12-15',
//       method: 'Bank Transfer',
//       status: 'Completed',
//       commissions: 2,
//       reference: 'TRX2023356',
//       commissionDetails: [
//         { bookingId: 'BK005', amount: '₹1,200', date: '2023-12-10' },
//         { bookingId: 'BK006', amount: '₹650', date: '2023-12-08' }
//       ]
//     },
//     {
//       id: 3,
//       paymentId: 'PAY003',
//       amount: '₹3,120',
//       date: '2023-11-20',
//       method: 'Bank Transfer',
//       status: 'Completed',
//       commissions: 4,
//       reference: 'TRX2023321',
//       commissionDetails: [
//         { bookingId: 'BK007', amount: '₹850', date: '2023-11-15' },
//         { bookingId: 'BK008', amount: '₹950', date: '2023-11-12' },
//         { bookingId: 'BK009', amount: '₹720', date: '2023-11-10' },
//         { bookingId: 'BK010', amount: '₹600', date: '2023-11-08' }
//       ]
//     },
//     {
//       id: 4,
//       paymentId: 'PAY004',
//       amount: '₹2,800',
//       date: '2023-10-15',
//       method: 'Bank Transfer',
//       status: 'Completed',
//       commissions: 3,
//       reference: 'TRX2023298',
//       commissionDetails: [
//         { bookingId: 'BK011', amount: '₹1,100', date: '2023-10-12' },
//         { bookingId: 'BK012', amount: '₹900', date: '2023-10-10' },
//         { bookingId: 'BK013', amount: '₹800', date: '2023-10-08' }
//       ]
//     },
//     {
//       id: 5,
//       paymentId: 'PAY005',
//       amount: '₹1,950',
//       date: '2023-09-15',
//       method: 'Bank Transfer',
//       status: 'Completed',
//       commissions: 2,
//       reference: 'TRX2023276',
//       commissionDetails: [
//         { bookingId: 'BK014', amount: '₹1,200', date: '2023-09-12' },
//         { bookingId: 'BK015', amount: '₹750', date: '2023-09-10' }
//       ]
//     },
//     {
//       id: 6,
//       paymentId: 'PAY006',
//       amount: '₹3,450',
//       date: '2023-08-15',
//       method: 'Bank Transfer',
//       status: 'Completed',
//       commissions: 5,
//       reference: 'TRX2023254',
//       commissionDetails: [
//         { bookingId: 'BK016', amount: '₹800', date: '2023-08-12' },
//         { bookingId: 'BK017', amount: '₹700', date: '2023-08-10' },
//         { bookingId: 'BK018', amount: '₹650', date: '2023-08-08' },
//         { bookingId: 'BK019', amount: '₹900', date: '2023-08-05' },
//         { bookingId: 'BK020', amount: '₹400', date: '2023-08-03' }
//       ]
//     }
//   ];

//   // Use filtered payments or all payments
//   const displayedPayments = isFiltered ? filteredPayments : allPayments.slice(0, 4);
//   const allDisplayedPayments = isFiltered ? filteredPayments : allPayments;

//   // Calculate payment stats based on displayed data
//   const calculatePaymentStats = (payments) => {
//     const totalPaid = payments.reduce((sum, payment) => {
//       const amount = parseInt(payment.amount.replace('₹', '').replace(',', ''));
//       return sum + amount;
//     }, 0);
    
//     const totalPayments = payments.length;
//     const averagePayment = totalPayments > 0 ? Math.round(totalPaid / totalPayments) : 0;

//     return {
//       totalPaid: `₹${totalPaid.toLocaleString()}`,
//       totalPayments: totalPayments,
//       averagePayment: `₹${averagePayment.toLocaleString()}`,
//       nextPayment: '2024-02-20'
//     };
//   };

//   const paymentStats = calculatePaymentStats(allDisplayedPayments);

//   const handleFilterChange = (e) => {
//     setFilter({
//       ...filter,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleFilter = (e) => {
//     e.preventDefault();
    
//     let filtered = allPayments;

//     if (filter.month && filter.year) {
//       filtered = allPayments.filter(payment => {
//         const paymentDate = new Date(payment.date);
//         const paymentMonth = (paymentDate.getMonth() + 1).toString();
//         const paymentYear = paymentDate.getFullYear().toString();
        
//         return paymentMonth === filter.month && paymentYear === filter.year;
//       });
//     } else if (filter.year) {
//       filtered = allPayments.filter(payment => {
//         const paymentDate = new Date(payment.date);
//         const paymentYear = paymentDate.getFullYear().toString();
        
//         return paymentYear === filter.year;
//       });
//     }

//     setFilteredPayments(filtered);
//     setIsFiltered(true);
//   };

//   const handleReset = () => {
//     setFilter({
//       month: '',
//       year: new Date().getFullYear().toString()
//     });
//     setFilteredPayments([]);
//     setIsFiltered(false);
//   };

//   const handleExportCSV = () => {
//     const paymentsToExport = isFiltered ? filteredPayments : allPayments;
    
//     // Create CSV content
//     const headers = ['Payment ID', 'Amount', 'Payment Date', 'Payment Method', 'Commissions Included', 'Reference No', 'Status'];
//     const csvContent = [
//       headers.join(','),
//       ...paymentsToExport.map(payment => [
//         payment.paymentId,
//         payment.amount,
//         payment.date,
//         payment.method,
//         payment.commissions,
//         payment.reference,
//         payment.status
//       ].join(','))
//     ].join('\n');

//     // Create and download CSV file
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.setAttribute('hidden', '');
//     a.setAttribute('href', url);
//     a.setAttribute('download', `payments_report_${new Date().toISOString().split('T')[0]}.csv`);
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     window.URL.revokeObjectURL(url);
//   };

//   const handleViewAll = () => {
//     setShowAllPayments(true);
//   };

//   const handleViewDetails = (payment) => {
//     setSelectedPayment(payment);
//   };

//   const closeModal = () => {
//     setShowAllPayments(false);
//     setSelectedPayment(null);
//   };

//   const getMonthName = (monthNumber) => {
//     const months = [
//       'January', 'February', 'March', 'April', 'May', 'June',
//       'July', 'August', 'September', 'October', 'November', 'December'
//     ];
//     return months[parseInt(monthNumber) - 1] || '';
//   };

//   return (
//     <Layout>
//       <div className="payments-page">
//         <div className="page-header">
//           <h1 className="page-title">Payment Reports</h1>
//           <p className="page-subtitle">View your payment history and transaction details</p>
//         </div>

//         {/* Payment Statistics */}
//         <div className="payment-stats">
//           <div className="stat-card">
//             <div className="stat-icon">💰</div>
//             <div className="stat-content">
//               <h3>{paymentStats.totalPaid}</h3>
//               <p>Total Amount Paid</p>
//             </div>
//           </div>
//           <div className="stat-card">
//             <div className="stat-icon">📄</div>
//             <div className="stat-content">
//               <h3>{paymentStats.totalPayments}</h3>
//               <p>Total Payments</p>
//             </div>
//           </div>
//           <div className="stat-card">
//             <div className="stat-icon">📊</div>
//             <div className="stat-content">
//               <h3>{paymentStats.averagePayment}</h3>
//               <p>Average Payment</p>
//             </div>
//           </div>
//           <div className="stat-card">
//             <div className="stat-icon">📅</div>
//             <div className="stat-content">
//               <h3>{paymentStats.nextPayment}</h3>
//               <p>Next Payment Date</p>
//             </div>
//           </div>
//         </div>

//         {/* Filters */}
//         <div className="filters-section">
//           <form onSubmit={handleFilter} className="filter-form">
//             <div className="filter-group">
//               <label htmlFor="month">Month</label>
//               <select
//                 id="month"
//                 name="month"
//                 value={filter.month}
//                 onChange={handleFilterChange}
//               >
//                 <option value="">All Months</option>
//                 <option value="1">January</option>
//                 <option value="2">February</option>
//                 <option value="3">March</option>
//                 <option value="4">April</option>
//                 <option value="5">May</option>
//                 <option value="6">June</option>
//                 <option value="7">July</option>
//                 <option value="8">August</option>
//                 <option value="9">September</option>
//                 <option value="10">October</option>
//                 <option value="11">November</option>
//                 <option value="12">December</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label htmlFor="year">Year</label>
//               <select
//                 id="year"
//                 name="year"
//                 value={filter.year}
//                 onChange={handleFilterChange}
//               >
//                 <option value="2024">2024</option>
//                 <option value="2023">2023</option>
//                 <option value="2022">2022</option>
//                 <option value="2021">2021</option>
//               </select>
//             </div>
//             <button type="submit" className="filter-btn">
//               Apply Filter
//             </button>
//             <button type="button" className="reset-btn" onClick={handleReset}>
//               Reset
//             </button>
//           </form>
//           {isFiltered && (
//             <div className="filter-info">
//               {filter.month && filter.year ? (
//                 <p>Showing {filteredPayments.length} payments for {getMonthName(filter.month)} {filter.year}</p>
//               ) : filter.year ? (
//                 <p>Showing {filteredPayments.length} payments for {filter.year}</p>
//               ) : null}
//             </div>
//           )}
//         </div>

//         {/* Payments Table */}
//         <div className="payments-table-container">
//           <div className="table-header">
//             <h3>Payment History</h3>
//             <div className="table-actions">
//               <button className="view-all-btn" onClick={handleViewAll}>
//                 View All
//               </button>
//               <button className="export-btn" onClick={handleExportCSV}>
//                 Export Report
//               </button>
//             </div>
//           </div>
//           <div className="table-responsive">
//             <table className="payments-table">
//               <thead>
//                 <tr>
//                   <th>Payment ID</th>
//                   <th>Amount</th>
//                   <th>Payment Date</th>
//                   <th>Payment Method</th>
//                   <th>Commissions Included</th>
//                   <th>Reference No</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {displayedPayments.map((payment) => (
//                   <tr key={payment.id}>
//                     <td className="payment-id">{payment.paymentId}</td>
//                     <td className="amount">{payment.amount}</td>
//                     <td className="date">{payment.date}</td>
//                     <td className="method">{payment.method}</td>
//                     <td className="commissions-count">{payment.commissions}</td>
//                     <td className="reference">{payment.reference}</td>
//                     <td>
//                       <span className={`status-badge status-${payment.status.toLowerCase()}`}>
//                         {payment.status}
//                       </span>
//                     </td>
//                     <td>
//                       <button 
//                         className="view-details-btn"
//                         onClick={() => handleViewDetails(payment)}
//                       >
//                         View Details
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             {!isFiltered && allPayments.length > 4 && (
//               <div className="table-footer">
//                 <p>Showing 4 of {allPayments.length} payments</p>
//               </div>
//             )}
//             {isFiltered && filteredPayments.length === 0 && (
//               <div className="table-footer">
//                 <p>No payments found for the selected filter</p>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Payment Schedule */}
//         <div className="payment-schedule">
//           <h3>Payment Schedule</h3>
//           <div className="schedule-info">
//             <div className="schedule-item">
//               <span className="schedule-label">Payment Cycle:</span>
//               <span className="schedule-value">Monthly (15th of each month)</span>
//             </div>
//             <div className="schedule-item">
//               <span className="schedule-label">Minimum Payout:</span>
//               <span className="schedule-value">₹500</span>
//             </div>
//             <div className="schedule-item">
//               <span className="schedule-label">Payment Method:</span>
//               <span className="schedule-value">Bank Transfer</span>
//             </div>
//           </div>
//         </div>

//         {/* All Payments Modal */}
//         {showAllPayments && (
//           <div className="modal-overlay" onClick={closeModal}>
//             <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//               <div className="modal-header">
//                 <h3>All Payments ({allDisplayedPayments.length})</h3>
//                 <button className="modal-close" onClick={closeModal}>×</button>
//               </div>
//               <div className="modal-body">
//                 <div className="payments-table">
//                   <table>
//                     <thead>
//                       <tr>
//                         <th>Payment ID</th>
//                         <th>Amount</th>
//                         <th>Payment Date</th>
//                         <th>Payment Method</th>
//                         <th>Commissions Included</th>
//                         <th>Reference No</th>
//                         <th>Status</th>
//                         <th>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {allDisplayedPayments.map((payment) => (
//                         <tr key={payment.id}>
//                           <td className="payment-id">{payment.paymentId}</td>
//                           <td className="amount">{payment.amount}</td>
//                           <td className="date">{payment.date}</td>
//                           <td className="method">{payment.method}</td>
//                           <td className="commissions-count">{payment.commissions}</td>
//                           <td className="reference">{payment.reference}</td>
//                           <td>
//                             <span className={`status-badge status-${payment.status.toLowerCase()}`}>
//                               {payment.status}
//                             </span>
//                           </td>
//                           <td>
//                             <button 
//                               className="view-details-btn"
//                               onClick={() => handleViewDetails(payment)}
//                             >
//                               View Details
//                             </button>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button className="export-btn" onClick={handleExportCSV}>
//                   Export Report
//                 </button>
//                 <button className="close-btn" onClick={closeModal}>
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Payment Details Modal */}
//         {selectedPayment && (
//           <div className="modal-overlay" onClick={closeModal}>
//             <div className="modal-content payment-details-modal" onClick={(e) => e.stopPropagation()}>
//               <div className="modal-header">
//                 <h3>Payment Details - {selectedPayment.paymentId}</h3>
//                 <button className="modal-close" onClick={closeModal}>×</button>
//               </div>
//               <div className="modal-body">
//                 <div className="payment-details">
//                   <div className="detail-row">
//                     <span className="detail-label">Payment ID:</span>
//                     <span className="detail-value">{selectedPayment.paymentId}</span>
//                   </div>
//                   <div className="detail-row">
//                     <span className="detail-label">Amount:</span>
//                     <span className="detail-value">{selectedPayment.amount}</span>
//                   </div>
//                   <div className="detail-row">
//                     <span className="detail-label">Payment Date:</span>
//                     <span className="detail-value">{selectedPayment.date}</span>
//                   </div>
//                   <div className="detail-row">
//                     <span className="detail-label">Payment Method:</span>
//                     <span className="detail-value">{selectedPayment.method}</span>
//                   </div>
//                   <div className="detail-row">
//                     <span className="detail-label">Reference No:</span>
//                     <span className="detail-value">{selectedPayment.reference}</span>
//                   </div>
//                   <div className="detail-row">
//                     <span className="detail-label">Status:</span>
//                     <span className={`status-badge status-${selectedPayment.status.toLowerCase()}`}>
//                       {selectedPayment.status}
//                     </span>
//                   </div>
                  
//                   <div className="commissions-breakdown">
//                     <h4>Commissions Included ({selectedPayment.commissions})</h4>
//                     <div className="commissions-list">
//                       {selectedPayment.commissionDetails.map((commission, index) => (
//                         <div key={index} className="commission-item">
//                           <span className="commission-booking">{commission.bookingId}</span>
//                           <span className="commission-amount">{commission.amount}</span>
//                           <span className="commission-date">{commission.date}</span>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button className="close-btn" onClick={closeModal}>
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </Layout>
//   );
// };

// export default PaymentReport;

import React, { useState, useEffect } from 'react';
import Layout from '../../Component/Layout/Layout';
import { getInfluencerPayments } from '../../Services/Operations/ProductAPI';
import { toast } from 'react-toastify';
import '../../Styles/payments.css';
import { useSelector } from 'react-redux';

const PaymentReport = () => {
  const [filter, setFilter] = useState({
    month: '',
    year: new Date().getFullYear().toString()
  });
  const [showAllPayments, setShowAllPayments] = useState(false);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [allPayments, setAllPayments] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [paymentSummary, setPaymentSummary] = useState([]);

 const { token, loginData } = useSelector(state => state.influencer);

  useEffect(() => {
    fetchPayments();
  }, []);

  const fetchPayments = async (params = {}) => {
    try {
      setLoading(true);
      const response = await getInfluencerPayments(params, token);
      
      if (response.success) {
        setAllPayments(response.payments || []);
        setFilteredPayments(response.payments || []);
        setPaymentSummary(response.summary || []);
      } else {
        toast.error(response.message || 'Failed to fetch payments');
      }
    } catch (error) {
      console.error('Error fetching payments:', error);
      toast.error('Failed to load payment data');
    } finally {
      setLoading(false);
    }
  };

  // Calculate payment stats based on displayed data
  const calculatePaymentStats = (payments) => {
    const totalPaid = payments.reduce((sum, payment) => {
      const amount = parseFloat(payment.amount) || 0;
      return sum + amount;
    }, 0);
    
    const totalPayments = payments.length;
    const averagePayment = totalPayments > 0 ? Math.round(totalPaid / totalPayments) : 0;

    // Find next payment date (assuming payments are monthly on 15th)
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    let nextPaymentDate = new Date(currentYear, currentMonth, 15);
    
    // If today is past the 15th, next payment is next month
    if (today.getDate() > 15) {
      nextPaymentDate = new Date(currentYear, currentMonth + 1, 15);
    }

    return {
      totalPaid: `₹${totalPaid.toLocaleString('en-IN')}`,
      totalPayments: totalPayments,
      averagePayment: `₹${averagePayment.toLocaleString('en-IN')}`,
      nextPayment: nextPaymentDate.toISOString().split('T')[0]
    };
  };

  const paymentStats = calculatePaymentStats(allPayments);

  const handleFilterChange = (e) => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.value,
    });
  };

  const handleFilter = async (e) => {
    e.preventDefault();
    
    const params = {};
    if (filter.year) params.year = filter.year;
    if (filter.month) params.month = filter.month;

    try {
      setLoading(true);
      const response = await getInfluencerPayments(params, token);
      
      if (response.success) {
        setFilteredPayments(response.payments || []);
        setIsFiltered(true);
      } else {
        toast.error(response.message || 'Failed to filter payments');
      }
    } catch (error) {
      console.error('Error filtering payments:', error);
      toast.error('Failed to apply filter');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFilter({
      month: '',
      year: new Date().getFullYear().toString()
    });
    setFilteredPayments(allPayments);
    setIsFiltered(false);
  };

  const handleExportCSV = () => {
    const paymentsToExport = isFiltered ? filteredPayments : allPayments;
    
    // Create CSV content
    const headers = ['Payment ID', 'Amount', 'Payment Date', 'Payment Method', 'Commissions Included', 'Reference No', 'Status'];
    const csvContent = [
      headers.join(','),
      ...paymentsToExport.map(payment => [
        payment.paymentId,
        `₹${parseFloat(payment.amount).toLocaleString('en-IN')}`,
        new Date(payment.date).toISOString().split('T')[0],
        payment.method,
        payment.commissions,
        payment.reference,
        payment.status
      ].join(','))
    ].join('\n');

    // Create and download CSV file
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', `payments_report_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const handleViewAll = () => {
    setShowAllPayments(true);
  };

  const handleViewDetails = (payment) => {
    setSelectedPayment(payment);
  };

  const closeModal = () => {
    setShowAllPayments(false);
    setSelectedPayment(null);
  };

  const getMonthName = (monthNumber) => {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months[parseInt(monthNumber) - 1] || '';
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const formatAmount = (amount) => {
    return `₹${parseFloat(amount).toLocaleString('en-IN')}`;
  };

  // Get months with payments for filter dropdown
  const getAvailableMonths = () => {
    const months = new Set();
    paymentSummary.forEach(summary => {
      if (summary._id && summary._id.month) {
        months.add(summary._id.month);
      }
    });
    
    return Array.from(months).sort((a, b) => a - b).map(month => ({
      value: month.toString(),
      label: getMonthName(month)
    }));
  };

  // Get years with payments for filter dropdown
  const getAvailableYears = () => {
    const years = new Set();
    paymentSummary.forEach(summary => {
      if (summary._id && summary._id.year) {
        years.add(summary._id.year);
      }
    });
    
    // Add current year if not in summary
    const currentYear = new Date().getFullYear();
    years.add(currentYear);
    
    return Array.from(years).sort((a, b) => b - a).map(year => ({
      value: year.toString(),
      label: year.toString()
    }));
  };

  // Use filtered payments or all payments
  const displayedPayments = isFiltered ? filteredPayments : filteredPayments.slice(0, 4);
  const allDisplayedPayments = isFiltered ? filteredPayments : allPayments;

  return (
    <Layout>
      <div className="payments-page">
        <div className="page-header">
          <h1 className="page-title">Payment Reports</h1>
          <p className="page-subtitle">View your payment history and transaction details</p>
        </div>

        {/* Loading State */}
        {loading ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Loading payment data...</p>
          </div>
        ) : (
          <>
            {/* Payment Statistics */}
            <div className="payment-stats">
              <div className="stat-card">
                <div className="stat-icon">💰</div>
                <div className="stat-content">
                  <h3>{paymentStats.totalPaid}</h3>
                  <p>Total Amount Paid</p>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">📄</div>
                <div className="stat-content">
                  <h3>{paymentStats.totalPayments}</h3>
                  <p>Total Payments</p>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">📊</div>
                <div className="stat-content">
                  <h3>{paymentStats.averagePayment}</h3>
                  <p>Average Payment</p>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">📅</div>
                <div className="stat-content">
                  <h3>{paymentStats.nextPayment}</h3>
                  <p>Next Payment Date</p>
                </div>
              </div>
            </div>

            {/* Filters */}
            <div className="filters-section">
              <form onSubmit={handleFilter} className="filter-form">
                <div className="filter-group">
                  <label htmlFor="month">Month</label>
                  <select
                    id="month"
                    name="month"
                    value={filter.month}
                    onChange={handleFilterChange}
                    disabled={loading}
                  >
                    <option value="">All Months</option>
                    {getAvailableMonths().map(month => (
                      <option key={month.value} value={month.value}>
                        {month.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="filter-group">
                  <label htmlFor="year">Year</label>
                  <select
                    id="year"
                    name="year"
                    value={filter.year}
                    onChange={handleFilterChange}
                    disabled={loading}
                  >
                    <option value="">All Years</option>
                    {getAvailableYears().map(year => (
                      <option key={year.value} value={year.value}>
                        {year.label}
                      </option>
                    ))}
                  </select>
                </div>
                <button type="submit" className="filter-btn" disabled={loading}>
                  {loading ? 'Applying...' : 'Apply Filter'}
                </button>
                <button type="button" className="reset-btn" onClick={handleReset} disabled={loading}>
                  Reset
                </button>
              </form>
              {isFiltered && (
                <div className="filter-info">
                  {filter.month && filter.year ? (
                    <p>Showing {filteredPayments.length} payments for {getMonthName(filter.month)} {filter.year}</p>
                  ) : filter.year ? (
                    <p>Showing {filteredPayments.length} payments for {filter.year}</p>
                  ) : null}
                </div>
              )}
            </div>

            {/* Payments Table */}
            <div className="payments-table-container">
              <div className="table-header">
                <h3>Payment History</h3>
                <div className="table-actions">
                  <button 
                    className="view-all-btn" 
                    onClick={handleViewAll}
                    disabled={allPayments.length <= 4}
                  >
                    View All ({allPayments.length})
                  </button>
                  <button className="export-btn" onClick={handleExportCSV} disabled={allPayments.length === 0}>
                    Export Report
                  </button>
                </div>
              </div>
              <div className="table-responsive">
                {allPayments.length === 0 ? (
                  <div className="no-data">
                    <p>No payment records found</p>
                  </div>
                ) : (
                  <>
                    <table className="payments-table">
                      <thead>
                        <tr>
                          <th>Payment ID</th>
                          <th>Amount</th>
                          <th>Payment Date</th>
                          <th>Payment Method</th>
                          <th>Commissions Included</th>
                          <th>Reference No</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {displayedPayments.map((payment) => (
                          <tr key={payment._id}>
                            <td className="payment-id">{payment.paymentId}</td>
                            <td className="amount">{formatAmount(payment.amount)}</td>
                            <td className="date">{formatDate(payment.date)}</td>
                            <td className="method">{payment.method}</td>
                            <td className="commissions-count">{payment.commissions}</td>
                            <td className="reference">{payment.reference}</td>
                            <td>
                              <span className={`status-badge status-${payment.status.toLowerCase()}`}>
                                {payment.status}
                              </span>
                            </td>
                            <td>
                              <button 
                                className="view-details-btn"
                                onClick={() => handleViewDetails(payment)}
                              >
                                View Details
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {!isFiltered && allPayments.length > 4 && (
                      <div className="table-footer">
                        <p>Showing 4 of {allPayments.length} payments</p>
                      </div>
                    )}
                    {isFiltered && filteredPayments.length === 0 && (
                      <div className="table-footer">
                        <p>No payments found for the selected filter</p>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>

            {/* Monthly Summary */}
            {paymentSummary.length > 0 && (
              <div className="payment-summary">
                <h3>Monthly Payment Summary</h3>
                <div className="summary-cards">
                  {paymentSummary.map((summary, index) => (
                    <div key={index} className="summary-card">
                      <div className="summary-header">
                        <h4>{getMonthName(summary._id?.month)} {summary._id?.year}</h4>
                      </div>
                      <div className="summary-content">
                        <p>Total Paid: <strong>₹{summary.totalPaid?.toLocaleString('en-IN')}</strong></p>
                        <p>Payments: <strong>{summary.paymentCount}</strong></p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Payment Schedule */}
            <div className="payment-schedule">
              <h3>Payment Schedule</h3>
              <div className="schedule-info">
                <div className="schedule-item">
                  <span className="schedule-label">Payment Cycle:</span>
                  <span className="schedule-value">Monthly (15th of each month)</span>
                </div>
                <div className="schedule-item">
                  <span className="schedule-label">Minimum Payout:</span>
                  <span className="schedule-value">₹500</span>
                </div>
                <div className="schedule-item">
                  <span className="schedule-label">Payment Method:</span>
                  <span className="schedule-value">Bank Transfer</span>
                </div>
              </div>
            </div>
          </>
        )}

        {/* All Payments Modal */}
        {showAllPayments && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>All Payments ({allDisplayedPayments.length})</h3>
                <button className="modal-close" onClick={closeModal}>×</button>
              </div>
              <div className="modal-body">
                <div className="payments-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Payment ID</th>
                        <th>Amount</th>
                        <th>Payment Date</th>
                        <th>Payment Method</th>
                        <th>Commissions Included</th>
                        <th>Reference No</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allDisplayedPayments.map((payment) => (
                        <tr key={payment._id}>
                          <td className="payment-id">{payment.paymentId}</td>
                          <td className="amount">{formatAmount(payment.amount)}</td>
                          <td className="date">{formatDate(payment.date)}</td>
                          <td className="method">{payment.method}</td>
                          <td className="commissions-count">{payment.commissions}</td>
                          <td className="reference">{payment.reference}</td>
                          <td>
                            <span className={`status-badge status-${payment.status.toLowerCase()}`}>
                              {payment.status}
                            </span>
                          </td>
                          <td>
                            <button 
                              className="view-details-btn"
                              onClick={() => handleViewDetails(payment)}
                            >
                              View Details
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer">
                <button className="export-btn" onClick={handleExportCSV}>
                  Export Report
                </button>
                <button className="close-btn" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Payment Details Modal */}
        {selectedPayment && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content payment-details-modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Payment Details - {selectedPayment.paymentId}</h3>
                <button className="modal-close" onClick={closeModal}>×</button>
              </div>
              <div className="modal-body">
                <div className="payment-details">
                  <div className="detail-row">
                    <span className="detail-label">Payment ID:</span>
                    <span className="detail-value">{selectedPayment.paymentId}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Amount:</span>
                    <span className="detail-value">{formatAmount(selectedPayment.amount)}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Payment Date:</span>
                    <span className="detail-value">{formatDate(selectedPayment.date)}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Payment Method:</span>
                    <span className="detail-value">{selectedPayment.method}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Reference No:</span>
                    <span className="detail-value">{selectedPayment.reference}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Status:</span>
                    <span className={`status-badge status-${selectedPayment.status.toLowerCase()}`}>
                      {selectedPayment.status}
                    </span>
                  </div>
                  
                  <div className="commissions-breakdown">
                    <h4>Commissions Included ({selectedPayment.commissions})</h4>
                    <div className="commissions-list">
                      {selectedPayment.commissionDetails?.map((commission, index) => (
                        <div key={index} className="commission-item">
                          <div className="commission-detail">
                            <span className="detail-label">Booking ID:</span>
                            <span className="detail-value">{commission.bookingId || 'N/A'}</span>
                          </div>
                          <div className="commission-detail">
                            <span className="detail-label">PNR:</span>
                            <span className="detail-value">{commission.pnr || 'N/A'}</span>
                          </div>
                          <div className="commission-detail">
                            <span className="detail-label">Amount:</span>
                            <span className="detail-value">{formatAmount(commission.amount)}</span>
                          </div>
                          <div className="commission-detail">
                            <span className="detail-label">Customer:</span>
                            <span className="detail-value">{commission.customerName || 'N/A'}</span>
                          </div>
                          <div className="commission-detail">
                            <span className="detail-label">Route:</span>
                            <span className="detail-value">{commission.journeyRoute || 'N/A'}</span>
                          </div>
                          <div className="commission-detail">
                            <span className="detail-label">Journey Date:</span>
                            <span className="detail-value">{commission.journeyDate ? formatDate(commission.journeyDate) : 'N/A'}</span>
                          </div>
                          <div className="commission-detail">
                            <span className="detail-label">Bus Type:</span>
                            <span className="detail-value">{commission.busType || 'N/A'}</span>
                          </div>
                          <div className="commission-detail">
                            <span className="detail-label">Booking Amount:</span>
                            <span className="detail-value">{commission.bookingAmount ? formatAmount(commission.bookingAmount) : 'N/A'}</span>
                          </div>
                          <div className="commission-detail">
                            <span className="detail-label">Commission Rate:</span>
                            <span className="detail-value">{commission.commissionRate ? `${commission.commissionRate}%` : 'N/A'}</span>
                          </div>
                          <hr className="commission-divider" />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="close-btn" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default PaymentReport;